module.exports = __webpack_public_path__ + "static/media/furniture-3.ec55ad6b.jpg";